module.exports = __webpack_public_path__ + "static/media/07ssh.98e0c09d.png";